/* 🤖 this file was generated by svg-to-ts */
export const DfIconArrowUpRightOut12: {
  name: 'arrow-up-right-out-12';
  data: string;
} = {
  name: 'arrow-up-right-out-12',
  data: `<svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M10.395 2.88 6.54 6.735A.901.901 0 1 1 5.265 5.46L9.12 1.606 8.098.585A.333.333 0 0 1 8.33.016L11.654 0c.184 0 .333.147.334.331v3.336a.333.333 0 0 1-.568.236l-1.025-1.024zM5 1v2H3a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V7h2v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2z"/></svg>`
};
